import dynamic from 'next/dynamic';
//components
//store
//utils & services
import fetchModelDetails from 'src/modules/newCars/services/fetchModelDetails';
import fetchStrapiContent from 'src/modules/newCars/services/fetchStrapiContent';
import { handleQuery } from 'src/modules/newCars/utils/handleQuery';
//constants & types
import { WEBSITE_URL } from 'core-lib/data/common';
import { getRandomNum } from 'core-lib/utils/helpers';
import dayjs from 'dayjs';
import NavbarLayout from 'src/common/components/NavbarLayout';
import { mapping } from 'src/modules/newCars/constants/newMappingArray';
import { RESERVED_URLS } from 'src/modules/newCars/constants/url';
import fetchAllStrapiContent from 'src/modules/newCars/services/fetchAllStrapiContent';
import fetchBrandData from 'src/modules/newCars/services/fetchBrandDetails';
import fetchFilterData from 'src/modules/newCars/services/fetchFilterData';
import fetchRedirectionData from 'src/modules/newCars/services/fetchRedirectionData';
import fetchVariantDetails from 'src/modules/newCars/services/fetchVariantDetails';
import fetchCityList from 'src/modules/newCars/services/getCityList';
import { BrandListType } from 'src/modules/newCars/types';
import { getCookie } from 'src/modules/newCars/utils/getCookie';
import { slugToTitle } from 'src/modules/newCars/utils/helper';
import {
  processSeoModelDetailData,
  processVariantContent,
} from 'src/modules/newCars/utils/seoContent';
import { addLog } from '../../server/utils/logger';
//component dynamic imports
const Listing = dynamic(
  () => import('src/modules/newCars/components/layouts/Listing'),
  {
    ssr: true,
  }
);
const Model = dynamic(
  () => import('src/modules/newCars/components/layouts/Model'),
  {
    ssr: true,
  }
);
const Variant = dynamic(
  () => import('src/modules/newCars/components/layouts/Variant'),
  {
    ssr: true,
  }
);

const CarListing = ({
  layout,
  content,
  itemListContent,
  vehicleSchema,
  itemListSchemaNew,
  strapiContent,
  brandList,
  filterPayload,
  params,
  priceDetail,
  cookies,
  variantSpecsInModel,
  itemListTitle,
}) => {
  return (
    <NavbarLayout
      footer={{ show: true }}
      breadCrumb={{ show: false, data: strapiContent?.breadCrumb }}
      header={{ show: true }}
      mobileApplicationSchema={{ show: true }}
      pageHeader={{
        show: true,
        backBtn: { show: false, onClick: () => {} },
        showProfile: false,
        showMenu: true,
      }}
      vehicleSchema={{
        show: true,
        data: vehicleSchema,
      }}
      itemListSchemaNew={{
        show: true,
        data: itemListSchemaNew,
      }}
    >
      {
        {
          0: <div className="cmn_error_div">Temporarily Unavailable</div>,
          1: (
            <Listing
              content={content}
              itemListTitle={itemListTitle}
              itemListContent={itemListContent}
              strapiContent={strapiContent}
              brandList={brandList}
              filterPayload={filterPayload || 'brand'}
              slug={params}
            />
          ),
          2: (
            <Model
              content={content}
              strapiContent={strapiContent}
              slug={params.slug}
              priceDetail={priceDetail}
              cookies={cookies}
              variantSpecsInModel={variantSpecsInModel}
            />
          ),
          3: <Variant content={content} strapiContent={strapiContent} />,
        }[layout]
      }
    </NavbarLayout>
  );
};
export default CarListing;

export async function getServerSideProps({ query, params, res, req }) {
  const cookie = req.headers.cookie;
  let citySelectedId = Number(getCookie('cityId', cookie)) || 4;
  let citySelectedName = getCookie('cityName', cookie) || 'New Delhi';
  const { slug } = params;

  let itemListTitle = slugToTitle(params.slug);
  if (
    query?.params?.[query.slug.length - 1]?.includes('varient') ||
    slug?.[2] === 'price'
  ) {
    let url = query?.params
      ?.join('/')
      .replace('varient', 'variant')
      // eslint-disable-next-line no-useless-escape
      .replace(/[^0-9a-zA-Z-\/ \.]/gi, '');
    if (slug?.[2] === 'price') {
      url = query?.slug?.join('/').replace('price', 'price-in-new-delhi');
    }
    res.writeHead(301, { location: `${WEBSITE_URL}/new-cars/${url}` });
    res.end();
  }
  const pageUrl = `${WEBSITE_URL}/new-cars/${slug.join('/')}`;
  let content = null;
  let itemListContent = null;
  let variantSpecsInModel = null;
  let priceDetail = null;
  let brandList: BrandListType[] | null = null;
  let strapiContent = null;
  let layout = 0;
  let cookies = null;

  const { isValidRoute, isFilter, filterPayload, city } = handleQuery(slug);
  async function isValidCityFunction(city) {
    const { response: cityList } = await fetchCityList();
    if (cityList) {
      const cityObject = cityList?.find(
        (item) => item?.slug?.toLowerCase() === city
      );
      if (cityObject !== undefined) {
        return cityObject;
      } else {
        return null;
      }
    }
  }
  if (isFilter && isValidRoute) {
    layout = 1;
    const payload = {
      ...filterPayload,
      discontinued: false,
      page: Number(query?.page) || 1,
      limit: 10,
    };
    brandList = await fetchBrandData();
    if (!brandList) {
      addLog({
        level: 'error',
        category: 'new-cars',
        data: {
          api: 'brands-api',
          pageUrl: pageUrl,
        },
      });
    }
    content = await fetchFilterData(payload);
    const itemListPayload = {
      ...filterPayload,
      discontinued: false,
      page: 1,
      limit: 10,
    };
    itemListContent = await fetchFilterData(itemListPayload);
    if (!content) {
      addLog({
        level: 'error',
        category: 'new-cars',
        data: {
          api: 'ilters-api',
          pageUrl: pageUrl,
        },
      });
    }
    let filterData = await fetchStrapiContent('filter', query?.slug?.join('-'));
    strapiContent = { carListing: filterData };
    if (!strapiContent?.carListing) {
      let filterData = await fetchStrapiContent('filter', 'filter-dynamic');
      strapiContent = { carListing: filterData };
    }
  } else if (!isFilter && isValidRoute) {
    layout = slug?.length;
    if (slug.length === 1) {
      brandList = await fetchBrandData();
      if (!brandList) {
        addLog({
          level: 'error',
          category: 'new-cars',
          data: {
            api: 'brands-api',
            pageUrl: pageUrl,
          },
        });
      }
      const brandSlug = slug?.[0]?.replace('-car', '');
      const payload = {
        brand_slug: [`${brandSlug}`],
        discontinued: false,
        page: Number(query?.page) || 1,
        limit: 10,
      };
      const itemListPayload = {
        brand_slug: [`${brandSlug}`],
        discontinued: false,
        page: 1,
        limit: 10,
      };

      content = await fetchFilterData(payload);
      if (!content) {
        addLog({
          level: 'error',
          category: 'new-cars',
          data: {
            api: 'model-list-api',
            pageUrl: pageUrl,
          },
        });
      }

      itemListContent = await fetchFilterData(itemListPayload);

      const allData = await fetchAllStrapiContent('brand', slug[0]);
      if (allData?.data) {
        strapiContent = allData.data;
      }
    } else if (
      slug?.length === 2 ||
      (slug?.length === 3 &&
        (RESERVED_URLS?.includes(slug[2]) || slug[2]?.includes('price-in')))
    ) {
      //Model page amd model variant page
      layout = 2;
      if (city) {
        let isValidCity = await isValidCityFunction(city);
        if (isValidCity == null) {
          layout = 0;
          content = null;
        } else {
          citySelectedId = isValidCity?.id;
          citySelectedName = isValidCity?.name;
        }
      }
      //1. API CALL and handling for model pages and TAB pages
      const allData = await fetchAllStrapiContent('model', slug[0], slug[1]);
      if (allData.data) {
        strapiContent = allData.data;
      }
      //2. API to fetch modelDetail
      content = await fetchModelDetails(slug[1], citySelectedId);
      if (!content) {
        addLog({
          level: 'error',
          category: 'new-cars',
          data: {
            api: 'model-detail-api',
            pageUrl: pageUrl,
          },
        });
      }

      if (content?.hero?.brandName) {
        let cookieVariantId = getCookie('variantId', cookies);
        let variantSelected;
        if(cookieVariantId){
          variantSelected = +cookieVariantId
        }
        else variantSelected = content?.variants?.[0]?.variantKey || null;

        cookies = {
          cityId: citySelectedId,
          variantId: variantSelected,
          cityName: citySelectedName,
          cookieExists: !city?.length,
        };
        variantSpecsInModel = await fetchVariantDetails({
          modelDetail: content,
          id: variantSelected,
        });
        priceDetail = content?.priceResponse?.filter((item) => {
          return item?.variantId === variantSelected;
        });
        priceDetail = priceDetail[0];
      }
    } else if (slug?.length === 3) {
      //Variant page
      const modelDetail = await fetchModelDetails(slug[1], citySelectedId);
      if (!modelDetail) {
        addLog({
          level: 'error',
          category: 'new-cars',
          data: {
            api: 'model-detail-api',
            pageUrl: pageUrl,
          },
        });
      }
      content = await fetchVariantDetails({
        modelDetail: modelDetail,
        slug: slug?.[2]?.replace('-variant', ''),
      });
      if (!content) {
        addLog({
          level: 'error',
          category: 'new-cars',
          data: {
            api: 'model-detail-api',
            pageUrl: pageUrl,
          },
        });
      }
      let allData = await fetchAllStrapiContent(
        'variant',
        slug[0],
        slug[1],
        slug[2]
      );
      if (allData?.data) {
        strapiContent = allData.data;
      }
    }
  }

  if (!content || content === null) {
    let url;
    if (query?.slug[2] != undefined) {
      url = `${WEBSITE_URL}/new-cars/${query?.slug[0]}/${query?.slug[1]}/${query?.slug[2]}`;
    } else if (query?.slug[1] != undefined) {
      url = `${WEBSITE_URL}/new-cars/${query?.slug[0]}/${query?.slug[1]}`;
    } else if (query?.slug[0] != undefined) {
      url = `${WEBSITE_URL}/new-cars/${query?.slug[0]}/${query?.slug[1]}`;
    }
    let redirectUrl = mapping[url];
    if (!redirectUrl) {
      const { response, error }: any = await fetchRedirectionData({
        brand: query?.slug[0] ?? '',
        model: query?.slug[1] ?? '',
        variant: query?.slug[2] ?? '',
      });
      if (response) {
        redirectUrl = `${WEBSITE_URL}/new-cars/${response}`;
      }
    }
    if (redirectUrl) {
      return {
        redirect: {
          permanent: true,
          destination: redirectUrl,
        },
      };
    } else {
      return {
        notFound: true,
      };
    }
  }

  if (layout === 0 || content === null) {
    return {
      props: {
        layout: layout || null,
        content: content || null,
      },
    };
  }
  const breadCrumb = slug[1]
    ? [
        {
          id: getRandomNum(),
          name: 'Home',
          type: 'internal',
          url: '/',
        },
        {
          id: getRandomNum(),
          name: 'New Cars',
          type: 'internal',
          url: '/new-cars',
        },
        {
          id: getRandomNum(),
          name: slug[0]?.split('-')?.join(' '),
          type: 'internal',
          url: `/new-cars/${slug[0]}`,
        },
        {
          id: getRandomNum(),
          name: slug[1]?.split('-')?.join(' '),
          type: 'internal',
          url: `/new-cars/${slug[0]}/${slug[1]}`,
        },
      ]
    : [
        {
          id: getRandomNum(),
          name: 'Home',
          type: 'internal',
          url: '/',
        },
        {
          id: getRandomNum(),
          name: 'New Cars',
          type: 'internal',
          url: '/new-cars',
        },
        {
          id: getRandomNum(),
          name: slug[0]?.split('-')?.join(' '),
          type: 'internal',
          url: `/new-cars/${slug[0]}`,
        },
      ];
  if (!content || content === null) {
    return {
      notFound: true,
    };
  }
  if (layout === 1 && content?.noOfModels === 0) {
    return {
      notFound: true,
    };
  }
  const publishingReviews = strapiContent?.userReview?.slice(0, 5);
  const createItemObj = (data) => {
    const obj = {
      numberOfItems: data?.modelList?.length,
      itemList: data?.modelList?.map((model, index) => {
        return {
          position: index + 1,
          url: `${WEBSITE_URL}/new-cars/${slug.join()}/${model.modelSlug}`,
          itemName: model?.name,
          image: model?.image,
          brandName: model?.brandName,
          offerPrice: model?.minPrice,
          offerUrl: `${WEBSITE_URL}/cars/${slug.join()}/${model.modelSlug}`,
        };
      }),
    };
    return obj;
  };

  const createObj = (data) => {
    let obj = {};
    let description: any = '';
    if (
      slug?.length === 2 ||
      (slug?.length === 3 &&
        (RESERVED_URLS?.includes(slug[2]) || slug[2]?.includes('price-in')))
    ) {
      const modelData: any = processSeoModelDetailData(
        strapiContent?.carListing,
        content
      );
      description = modelData?.seoDescription;
      obj = {
        brand: data?.hero?.brandName || null,
        name: data?.hero?.modelName || null,
        description: description || null,
        bodyType: data?.hero?.bodyType || null,
        image: data?.hero?.image || null,
        ...(data?.hero?.launchDate && {
          modelDate: dayjs(data?.hero?.launchDate).format('YYYY'),
        }),
        fuelCapacity: '40',
        numberOfAirBags: '4',
        vehicleTransmission: data?.hero?.transmission?.join(', ') || null,
        numberOfDoors: 4,
        aggregateRating: {
          ratingValue: data?.hero?.ratingValue || null,
          reviewCount: data?.hero?.reviewCount || null,
        },
        topReviews: publishingReviews || null,
        vehicleEngine: {
          fuelType: data?.hero?.fuelType.join(', ') || null,
          engineType: data?.hero?.engineType?.join(', ') || null,
          engineDisplacement: data?.hero?.engineDisplacement || null,
          torque: '280 lb-ft',
          enginePower: data?.hero?.enginePower || null,
        },
        driveWheelConfiguration: 'All Wheel Drive',
        mileageFromOdometer: {
          value: data?.hero?.mileage || null,
        },
        accelerationTime: {
          value: '6.5 seconds',
          unitText: '0-60 mph',
        },
        weightTotal: {
          value: '4100 lbs',
          unitText: 'pounds',
        },
        vehicleInteriorColor: 'Black',
        seatingCapacity: data?.hero?.seatingCapacity.join() || null,
        color: 'Blue',
        manufacturer: {
          name: 'Manufacturer Name',
          url: 'https://manufacturer.com',
        },
        offers: {
          priceCurrency: 'INR',
          price: data?.hero?.minPrice || null,
        },
        price: data?.hero?.minPrice || null,
      };
    } else if (slug?.length === 3) {
      description = processVariantContent(
        strapiContent?.carListing?.seoDescription,
        content
      );
      obj = {
        brand: data?.brandName || null,
        name: data?.modelName || null,
        description: description || null,
        bodyType: data?.bodyType || null,
        ...(data?.hero?.launchDate && {
          modelDate: dayjs(data?.hero?.launchDate).format('YYYY'),
        }),
        fuelCapacity: '40',
        numberOfAirBags: '4',
        vehicleTransmission: data?.transmission || null,
        numberOfDoors: 4,
        aggregateRating: {
          ratingValue: '4.5',
          reviewCount: '50',
        },
        topReviews: publishingReviews || null,
        vehicleEngine: {
          fuelType: data?.fuelType || null,
          engineType: data?.engineType || null,
          engineDisplacement: data?.engineDisplacement || null,
          torque: data?.torque || null,
          enginePower: data?.enginePower || null,
        },
        driveWheelConfiguration: 'All Wheel Drive',
        mileageFromOdometer: {
          value: data?.mileage || null,
        },
        accelerationTime: {
          value: '6.5 seconds',
          unitText: '0-60 mph',
        },
        weightTotal: {
          value: '4100 lbs',
          unitText: 'pounds',
        },
        vehicleInteriorColor: 'Black',
        seatingCapacity: data?.seatingCapacity || null,
        color: 'Blue',
        manufacturer: {
          name: 'Manufacturer Name',
          url: 'https://manufacturer.com',
        },
        offers: {
          priceCurrency: 'INR',
          price: data?.price || null,
        },
        price: data?.price || null,
      };
    }
    return obj;
  };
  let vehicleSchema: any = slug?.length > 1 ? createObj(content) : {};
  let itemListSchemaNew: any = slug?.length === 1 ? createItemObj(content) : {};
  return {
    props: {
      layout: layout || null,
      content: content || null,
      itemListContent: itemListContent || null,
      vehicleSchema: vehicleSchema,
      itemListSchemaNew: itemListSchemaNew,
      priceDetail: priceDetail || null,
      strapiContent: { ...strapiContent },
      brandList: brandList || null,
      variantSpecsInModel: variantSpecsInModel?.detailedSpecifications || null,
      query,
      params,
      cookies,
      filterPayload: filterPayload || null,
      itemListTitle: itemListTitle || null,
    },
  };
}
